// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".business-info__headline[data-v-38d2877f]{line-height:1.2}@media only screen and (max-width:599.98px){.about-us[data-v-38d2877f]{max-height:200rem;overflow:hidden;transition:max-height 1s}.about-us[data-v-38d2877f]:not(.extended){-webkit-line-clamp:10;-webkit-box-orient:vertical;display:-webkit-box;max-height:240px;overflow:hidden;text-overflow:ellipsis}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
